import styles from './banner.module.scss'
import { Cross, ClearChoiceMaxLogo } from '@/assets/icons'
import { ravenSDKHomeTrigger } from '@/analytics/raven/ravenSDKHelper'
import useInView from '@/utils/hooks/useInView'
import { useEffect } from 'react'

interface ClearChoiceMaxBannerProps {
    isCross?: boolean
    onCrossClick?: () => void
    isHomePage?: boolean
}

const ClearMax = ({ isCross = false, onCrossClick = () => {}, isHomePage = false }: ClearChoiceMaxBannerProps) => {
    
    useEffect(() => {
        if (isHomePage) {
            ravenSDKHomeTrigger('a_merch_widget_impression', {
                action_name: 'merch_impression',
                object_id: 'clearchoicemax_banner',
                url: 'www.cleartrip.com/lp/clearchoice-max',
                src: 'n/a'
            })
        }
    }, [])

    const { ref } = useInView({
        triggerOnce: true,
        skip: !isHomePage,
        onChange: (inView) => {
            if (inView && isHomePage) {
                ravenSDKHomeTrigger('a_merch_widget_view', {
                    action_name: 'merch_view',
                    object_id: 'clearchoicemax_banner',
                    url: 'www.cleartrip.com/lp/clearchoice-max',
                    src: 'n/a'
                })
            }
        }
    })

    const handleLearnMoreClick = () => {
        if (isHomePage) {
            ravenSDKHomeTrigger('a_merch_widget_click', {
                action_name: 'merch_click',
                object_id: 'clearchoicemax_banner',
                url: 'www.cleartrip.com/lp/clearchoice-max',
                src: 'n/a'
            })
        }
    }
    return (
        <>
            <div
                ref={ref}
                className="flex flex-middle flex-between my-4 px-4 py-4 br-8 p-relative o-hidden z-10"
                style={{ background: 'var(--Grapetini-100, #F2EDF9)', height: '90px' }}
            >
                <div>
                    <ClearChoiceMaxLogo />
                    <span className="flex flex-between statement">
                        Free cancellation or free date change starting from ₹499. T&C apply.
                    </span>
                </div>
                <div className="semicircle"></div>
                <div className="square"></div>
                <div className="circle"></div>
                <div className="flex flex-middle flex-row">
                    <a
                        className="px-3 py-2 fs-14 flex flexcenter flex-middle flex-no-shrink c-neutral-900 c-pointer td-none ba-solid  br-6 fw-600"
                        style={{ maxHeight: '32px', maxWidth: '110px' }}
                        href="/lp/clearchoice-max"
                        target="_blank"
                        title="Clearchoice Max"
                        onClick={() => handleLearnMoreClick()}
                    >
                        Learn more
                    </a>
                    {isCross && (
                        <div className="ml-6 c-pointer">
                            <Cross height={20} width={20} cursor="pointer" onClick={onCrossClick} />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default ClearMax
